<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <span ref="span">
        <input
          v-if="!readonly"
          type="text"
          ref="input"
          v-on:focus="focus = true"
          v-on:blur="focus = false"
          :id="inputLabel"
          class="inputWithMask"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
        />
        <label :for="inputLabel">
          <v-text-field
            tabindex="-1"
            :value="valueForInput"
            :label="`${label}`"
            :placeholder="placeholder"
            v-on:click:append="OpenPopUp"
            append-icon="mdi-chevron-down"
            :prepend-icon="icon ? 'mdi-calendar' : ''"
            :clearable="clearable && !readonly"
            @click:clear="clear()"
            ref="date"
            :rules="loading ? [] : [...rules, dateValidation]"
            :class="{
              'text-field': true,
              'date-input': focus,
              'active-menu': menu,
              'primary--text': focus,
              'v-input--is-focused': focus
            }"
            :loading="!hideLoading && loading"
            :readonly="readonly"
          >
          </v-text-field>
        </label>
      </span>
    </template>
    <v-date-picker
      :min="min"
      :max="max"
      :value="date"
      v-on:change="updateValueForInput"
      no-title
      scrollable
      :locale="$i18n.locale"
      color="primary"
      on-click="menu"
      @input="menu = false"
      :readonly="readonly"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
import { IMaskDirective } from "vue-imask";
import IMask from "imask/esm/imask";
let momentFormat = "DD.MM.YYYY";
export default {
  name: "dataInput",
  props: {
    date: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    icon: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: function() {
        return [];
      }
    },
    min: {
      type: String,
      default: ""
    },
    max: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideLoading: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    menu: false,
    focus: false,
    valueForInput: "",
    input: {},
    mask: {
      overwrite: true,
      lazy: false,
      autofix: true,
      mask: Date,

      pattern: momentFormat,
      min: new Date(1899, 0, 1),
      max: new Date(2101, 0, 1),

      format: function(date) {
        return moment(date).format(momentFormat);
      },
      parse: function(str) {
        return moment(str, momentFormat);
      },

      blocks: {
        YYYY: {
          mask: IMask.MaskedRange,
          from: 1900,
          to: 2100,
          placeholderChar: "y"
        },
        MM: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12,
          placeholderChar: "m"
        },
        DD: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 31,
          placeholderChar: "d"
        }
      }
    }
  }),
  computed: {
    inputLabel() {
      return "input-withMask-" + this._uid;
    }
  },
  watch: {
    date() {
      if (!this.date && !this.focus) {
        this.$refs.input.maskRef.value = "";
      }
      this.updateValueForInput(this.date);
    },
    valueForInput(e) {
      this.$nextTick(() => {
        if (e) {
          this.$refs.input.maskRef.value = e;
        }
      });
    },
    focus() {
      this.reCalcSizes();
    }
  },
  methods: {
    clear() {
      this.$refs.input.maskRef.value = "";
      this.updateDate("");
      let vm = this;
      setTimeout(function() {
        vm.$refs.input.focus();
      }, 0);
    },
    onAccept() {
      this.updateValueForInput(this.date);
    },
    onComplete(e) {
      let date = moment(e.value, momentFormat).format("YYYY-MM-DD");
      this.updateValueForInput(date);
    },

    OpenPopUp() {
      this.updateValueForInput(this.date);
      this.menu = true;
      clearTimeout(this.blur);
    },
    dateValidation: function(v) {
      let format =
        (this.$getLocaleDateFormat && this.$getLocaleDateFormat()) ||
        momentFormat;
      return (
        typeof v === "undefined" ||
        v === null ||
        v === "" ||
        v.toLowerCase() === momentFormat.toLowerCase() ||
        moment(v, format.toUpperCase()).isValid() ||
        moment(v, format.toLowerCase()).isValid() ||
        moment(v, format).isValid() ||
        this.$t("validate.date")
      );
    },
    updateValueForInput(date = "") {
      //date in Format  YYYY-MM-DD or just ""
      if (!date || moment(date, "YYYY-MM-DD").isValid()) {
        this.updateDate(date);
        this.valueForInput =
          date && moment(date, "YYYY-MM-DD").format(momentFormat);
      }
    },
    updateDate(date) {
      this.$emit("update", date);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    reCalcSizes() {
      function offset(el1, el2) {
        let rectEl1 = el1.getBoundingClientRect();
        let rectEl2 = el2.getBoundingClientRect();
        return {
          top: rectEl1.top - rectEl2.top,
          left: rectEl1.left - rectEl2.left
        };
      }
      let span = this.$refs.span;
      let input = span.querySelector(".v-text-field__slot input");
      let divOffset = offset(span, input);
      span.style.setProperty("--top", Math.abs(divOffset.top) + "px");
      span.style.setProperty("--left", Math.abs(divOffset.left) + "px");
      span.style.setProperty(
        "--primary",
        this.$vuetify.theme.currentTheme.primary
      );
    }
  },
  mounted() {
    let vm = this;
    let el = this.$refs.input;
    el.maskRef = IMask(el, this.mask)
      .on("accept", function() {
        return vm.onAccept(el.maskRef);
      })
      .on("complete", function() {
        return vm.onComplete(el.maskRef);
      });
    this.input = el.maskRef;
    let genIcon = this.$refs.date.genIcon.bind(this.$refs.date);
    this.$refs.date.genIcon = function(type, cb, extraData = {}) {
      let icon = genIcon(type, cb, extraData);
      if (icon.children[0]) {
        icon.children[0].data.attrs.tabindex = -1;
      }
      return icon;
    };
    this.$nextTick(() => {
      this.$forceUpdate();
    });
    this.updateValueForInput(this.date || "");
  },
  updated() {
    this.reCalcSizes();
  },
  directives: {
    imask: IMaskDirective
  }
};
</script>

<style scoped lang="scss">
span {
  background: var(--v-primary-base);
}
.date-input::v-deep .v-input__icon--append {
  transition: transform 0.3s ease-in-out;
}
.active-menu::v-deep .v-input__icon--append {
  transform: rotate(180deg);
}
.date-input::v-deep {
  .v-icon {
    color: var(--primary);
  }
  .v-label {
    color: var(--primary);
    max-width: 133%;
    -webkit-transform: translateY(-18px) scale(0.75);
    -ms-transform: translateY(-18px) scale(0.75);
    transform: translateY(-18px) scale(0.75);
  }
}
.text-field::v-deep .v-text-field__slot {
  user-select: none;
  pointer-events: none;
}
span {
  position: relative;
  display: inline-block;
  width: 100%;
}

.inputWithMask {
  position: absolute;
  opacity: 0;
  z-index: -11;
}
.inputWithMask:focus {
  position: absolute;
  display: inline-block;
  top: var(--top);
  left: var(--left);
  padding: 8px 0 8px;
  font-size: 14px;
  letter-spacing: normal;
  max-width: 100%;
  text-align: left;
  font-family: "Roboto", sans-serif;
  line-height: 16px;
  z-index: 2;
  width: calc(100% - var(--left) - 56px);
  opacity: 1;
}
.inputWithMask:focus + label .date-input::v-deep .v-text-field__slot {
  input {
    opacity: 0;
  }
}
</style>
